// Copyright 2026. WebPros International GmbH. All rights reserved.

import { api } from 'common/api/resources/Response';

export const fileStorage = {
    upload: (data: FormData) => api.post<string>('storage', data),
};
